import type { BiLogger } from '@wix/cli-telemetry';
import {
  createLoggedInLoginFlowMessage,
  emitLoginFlowMessage,
  isLoggedInToAccount,
  reportLoginStart,
  reportLoginSuccess,
  runAgentLoginFlow,
} from '@wix/cli-auth';

interface Options {
  biLogger: BiLogger;
}

export async function nonInteractiveLogin({
  biLogger,
}: Options): Promise<void> {
  const loggedInUser = await isLoggedInToAccount();

  if (loggedInUser) {
    reportLoginStart(biLogger);
    emitLoginFlowMessage(createLoggedInLoginFlowMessage(loggedInUser.userInfo));
    reportLoginSuccess(biLogger, loggedInUser.userInfo);

    return;
  }

  await runAgentLoginFlow({ biLogger });
}
